module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Storm-d0394d34e79b2a11dd7577da42f0ac9b.svg";